import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-shared-comment-table',
    templateUrl: './shared-comment-table.component.html',
    styleUrls: ['./shared-comment-table.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedCommentTableComponent implements OnInit {

    @Input() publicComment: string = null;

    @Input() privateComment: string = null;

    @Input() publicCommentLabel = 'Commentaire public';

    @Input() privateCommentLabel = 'Commentaire privé';

    constructor() {
    }

    get displayedCommentsList() {
        return [
            {
                label: `${this.publicCommentLabel} :`,
                comment: this.publicComment
            },
            {
                label: `${this.privateCommentLabel} :`,
                comment: this.privateComment
            }
        ].filter(({comment}) => !!comment);
    }

    stopPropagation($event) {
        $event.stopPropagation();
    }

    get hasComment(): boolean {
        return !!this.publicComment || !!this.privateComment;
    }

    ngOnInit() {
    }

}
